import {NgModule} from "@angular/core";
import {ClickOutsideDirective} from "./directives/click-outside.directive";
import {WebTemplateComponent} from "./web-template/web-template.component";
import {CodemirrorComponent, CodemirrorModule} from 'ng2-codemirror';
import { SnippetComponent } from './snippet/snippet.component';
import {FormsModule} from "@angular/forms";
import {Samples} from "./classes/Samples";

@NgModule ({
  declarations: [
    ClickOutsideDirective,
    WebTemplateComponent,
    SnippetComponent
  ],
  imports:[
    FormsModule,
    CodemirrorModule
  ],
  exports:[
    ClickOutsideDirective,
    WebTemplateComponent,
    CodemirrorComponent,
    SnippetComponent
  ],
  providers:[Samples]
})

export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts